export const HeaderFileName = ({ file }: { file: string }) => {
  return (
    <div className="truncate">
      <span className="text-[#364152] text-base font-bold font-montserrat">{file}</span>
    </div>
  );
};
